import {Component, ElementRef, EventEmitter, HostListener, Input, Output} from '@angular/core';

declare var moment;

@Component({
  selector: 'app-periodo-dropdown',
  templateUrl: './periodo-dropdown.component.html',
  styleUrls: ['./periodo-dropdown.component.scss']
})
export class PeriodoDropdownComponent {
  @Input() quickDateFilter: 'hoje' | 'ontem' | '7dias' | '30dias' | 'mes' | 'mesAnterior' | 'personalizado' = 'mes';
  @Input() filtroInicio: Date;
  @Input() filtroFim: Date;
  @Output() periodoAlterado = new EventEmitter<{inicio: Date, fim: Date, quickDateFilter: string}>();

  dropdownAberto = false;
  anoSelecionado: number = new Date().getFullYear();
  meses = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
  mesesCompletos = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

  constructor(private elRef: ElementRef) {}

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (this.dropdownAberto
        && !this.elRef.nativeElement.querySelector('.date-picker-wrapper')?.contains(target)
        && !target.closest('.k-animation-container')
        && !target.closest('.k-popup')
        && !target.closest('.k-calendar-container')) {
      this.dropdownAberto = false;
    }
  }

  toggleDropdown() {
    this.dropdownAberto = !this.dropdownAberto;
  }

  selecionarPreset(preset: 'hoje' | 'ontem' | '7dias' | '30dias' | 'mes' | 'mesAnterior' | 'personalizado') {
    if (preset === 'personalizado') {
      this.quickDateFilter = 'personalizado';
      return;
    }

    this.quickDateFilter = preset;
    let inicio: Date;
    let fim: Date;

    switch (preset) {
      case 'hoje':
        inicio = moment().startOf('day').toDate();
        fim = moment().endOf('day').toDate();
        break;
      case 'ontem':
        inicio = moment().subtract(1, 'days').startOf('day').toDate();
        fim = moment().subtract(1, 'days').endOf('day').toDate();
        break;
      case '7dias':
        inicio = moment().subtract(6, 'days').startOf('day').toDate();
        fim = moment().endOf('day').toDate();
        break;
      case '30dias':
        inicio = moment().subtract(29, 'days').startOf('day').toDate();
        fim = moment().endOf('day').toDate();
        break;
      case 'mes':
        inicio = moment().startOf('month').toDate();
        fim = moment().endOf('day').toDate();
        break;
      case 'mesAnterior':
        inicio = moment().subtract(1, 'month').startOf('month').toDate();
        fim = moment().subtract(1, 'month').endOf('month').toDate();
        break;
    }

    this.filtroInicio = inicio;
    this.filtroFim = fim;
    this.dropdownAberto = false;
    this.periodoAlterado.emit({inicio, fim, quickDateFilter: preset});
  }

  anoAnterior() {
    this.anoSelecionado--;
  }

  proximoAno() {
    this.anoSelecionado++;
  }

  selecionarMes(mesIndex: number) {
    this.quickDateFilter = 'personalizado';
    this.filtroInicio = moment().year(this.anoSelecionado).month(mesIndex).startOf('month').toDate();
    this.filtroFim = moment().year(this.anoSelecionado).month(mesIndex).endOf('month').toDate();
  }

  aplicarPeriodo() {
    if (this.filtroInicio && this.filtroFim) {
      this.quickDateFilter = 'personalizado';
      this.dropdownAberto = false;
      this.periodoAlterado.emit({
        inicio: this.filtroInicio,
        fim: this.filtroFim,
        quickDateFilter: 'personalizado'
      });
    }
  }

  obtenhaLabelPeriodo(): string {
    if (this.filtroInicio) {
      const inicio = moment(this.filtroInicio);
      const fim = this.filtroFim ? moment(this.filtroFim) : null;

      if (fim && inicio.isSame(fim, 'month') && inicio.date() === 1 &&
          (fim.date() === fim.daysInMonth() || fim.isSame(moment(), 'day'))) {
        return `${this.mesesCompletos[inicio.month()]} ${inicio.year()}`;
      }
    }

    const labels: any = {
      'hoje': 'Hoje',
      'ontem': 'Ontem',
      '7dias': 'Últimos 7 dias',
      '30dias': 'Últimos 30 dias'
    };
    if (labels[this.quickDateFilter]) return labels[this.quickDateFilter];

    if (this.filtroInicio && this.filtroFim) {
      return `${moment(this.filtroInicio).format('DD MMM')} - ${moment(this.filtroFim).format('DD MMM')}`;
    }
    return 'Personalizado';
  }

  obtenhaDescricaoDatas(): string {
    if (!this.filtroInicio || !this.filtroFim) return '';
    return `Exibindo de ${moment(this.filtroInicio).format('DD/MM/YYYY')} até ${moment(this.filtroFim).format('DD/MM/YYYY')}`;
  }

  mesSelecionadoAtivo(mesIndex: number): boolean {
    if (!this.filtroInicio) return false;
    const inicioMes = moment(this.filtroInicio);
    return inicioMes.month() === mesIndex && inicioMes.year() === this.anoSelecionado;
  }
}
